import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

// Defensive fallback to prevent runtime crash if env vars are missing
if (!supabaseUrl || !supabaseKey) {
  console.error(
    "Supabase environment variables are missing. Please check VITE_PUBLIC_SUPABASE_URL and VITE_PUBLIC_SUPABASE_ANON_KEY."
  );
}

export const supabase = createClient(
  supabaseUrl || "",
  supabaseKey || ""
);